import React from 'react';
import { FaStar, FaArrowRight } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className="relative w-full bg-[#050505] text-white overflow-hidden pt-24 pb-8">
            <div className="container mx-auto px-6 relative z-10">
                {/* Top Section */}
                <div className="mb-24">
                    {/* <div className="flex items-center gap-2 mb-6 text-blue-400">
                        <FaStar className="text-xs" />
                        <span className="text-sm font-medium uppercase tracking-wide">Contact Us</span>
                    </div> */}
                    <h2 className="text-4xl md:text-6xl font-medium leading-tight max-w-5xl text-white/90">
                        Don’t just design something that looks good — create something that feels alive the moment you touch it                    </h2>
                </div>

                {/* Middle Section */}
                <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-24 gap-12">
                    <div>
                        {/* <p className="text-gray-500 text-sm mb-2">Contact us at:</p> */}
                        <a href="mailto:hello@pixui.design" className="text-xl md:text-2xl text-white hover:text-blue-400 transition-colors flex items-center gap-2 group">
                            Design what you like
                            <FaArrowRight className="text-sm transform group-hover:-translate-y-1 group-hover:translate-x-1 transition-transform" />
                        </a>
                    </div>

                    <div className="flex gap-8 md:gap-12">
                        {['Components', 'Templates', 'Figma', 'Designs', 'Creativity'].map((item) => (
                            <a key={item} href="#" className="text-lg text-white/80 hover:text-white transition-colors">
                                {item}
                            </a>
                        ))}
                    </div>
                </div>

                {/* Bottom Logo Section */}
                <div className="relative w-full border-b border-white/10 pb-4 mb-6 flex items-end justify-between">
                    <div className="flex items-end gap-4">
                        <img src="/pixui-logo.svg" alt="PixUI Logo" className="w-24 h-24 md:w-48 md:h-40 object-contain md:mb-2" />
                        <h1 className="text-[15vw] leading-[0.8] font-bold tracking-tighter text-white select-none">
                            PixUI
                        </h1>
                    </div>
                    <div className="hidden md:flex gap-6 mb-4">
                        <a href="#" className="hover:text-white transition-colors text-sm">Follow us on Instagram</a>
                        {/* <a href="#" className="hover:text-white transition-colors text-sm">Instagram</a>
                        <a href="#" className="hover:text-white transition-colors text-sm">Twitter</a> */}
                    </div>
                </div>

                {/* Footer Bottom */}
                <div className="flex flex-col md:flex-row justify-between items-center text-xs text-gray-500">
                    <p>&copy; {new Date().getFullYear()} PixUI Labs. All rights reserved.</p>
                    <div className="flex gap-6 mt-4 md:mt-0">
                        <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
                        <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
                    </div>
                </div>
            </div>

            {/* Background Gradient */}
            <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-blue-900/20 rounded-full blur-[120px] pointer-events-none" />
            <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-purple-900/10 rounded-full blur-[120px] pointer-events-none" />
        </footer>
    );
};

export default Footer;
